import React, { Component } from 'react';
import LookupAddressModal from './address.lookup.modal';
import DDados from '../address.ddados';

class Container extends Component {
  constructor(props) {
    super(props);
    
  }

  render() {
    const columns = [
      { fieldName: 'CEP', dataName: 'CEP', show: true, type: 'text' },
      { fieldName: 'Logradouro', dataName: 'Logradouro', show: true, type: 'text' },
      { fieldName: 'Bairro', dataName: 'Bairro', show: true, type: 'text' },
      { fieldName: 'Cidade', dataName: 'Cidade', show: true, type: 'text' },
      { fieldName: 'UF', dataName: 'UF', show: true, type: 'text' },
      { fieldName: 'Tipo', dataName: 'Tipo', show: true, type: 'text' }
    ];

    const order = [{ fieldName: 'CEP', dataName: 'CEP', order: 'A' }];

    this.config = {
      columns: [...columns, { fieldName: 'Titulo', dataName: 'Titulo', show: true, type: 'text' }],
      columnsExterno: columns,
      order,
      parameters: this.props.parameters,
      title: `Pesquisa de ${DDados.Titulo}`,
    };

    return <LookupAddressModal {...this.config} {...this.props} />;
  }
}

export default Container;
